export const FETCH_SCHEMASELECTION_REQUEST = "FETCH_SCHEMASELECTION_REQUEST";
export const FETCH_SCHEMASELECTION_SUCCESS = "FETCH_SCHEMASELECTION_SUCCESS";
export const FETCH_SCHEMASELECTION_FAILURE = "FETCH_SCHEMASELECTION_FAILURE";